import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const EQUIPMENT_ACTION_TYPES = generateApiActionTypes('CARRIER_EQUIPMENT')
export const getEquipment = (carrierId: string) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.carriers,
      id: carrierId,
      group: 'equipment',
    },
    actionTypes: Object.keys(EQUIPMENT_ACTION_TYPES),
  },
})
